import fetchRefreshToken from './fetchRefreshToken'

const fetchDevice = async (token, keyM) => {
  // const newToken = await fetchRefreshToken().then(response => response)
  //   //sessionStorage.setItem('APIToken', newToken)
  //   const response = await fetch(`${process.env.REACT_APP_FETCH_DEV}rest/devices/device_sn/${sn}`, {
  //     method: "GET",
  //     headers:{
  //       "Authorization": `Bearer ${newToken}`
  //     }
  //   })
  //   .then(response => response.json())

    const response = await fetchRefreshToken().then(async newToken => {
      
      const res = await fetch(`${process.env.REACT_APP_FETCH_DEV}rest/provisioning/devices/${keyM}`, {
        method: "GET",
        headers:{
          "Authorization": `Bearer ${newToken}`
        }
      })
      .then(response => response.json())
      return res
    })

    return response
}

  export default fetchDevice